var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagDe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "flag-de_svg__a",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#flag-de_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD018",
  d: "M0 16h32v8H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E31D1C",
  d: "M0 8h32v8H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#272727",
  d: "M0 0h32v8H0z"
}))));
export default SvgFlagDe;